import { render } from "./IndexCamion.vue?vue&type=template&id=c51e98fc"
import script from "./IndexCamion.vue?vue&type=script&lang=js"
export * from "./IndexCamion.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__